import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      © 2025 - Waleria Stojanowska. Все права защищены
    </div>
  );
};

export default Footer;
